define(['underscore', 'text!./templates/basler-info-link.html'],
    (_, templateStr) => {

        return ['TextRetrievalService',
            function (TextRetrievalService) { //NOSONAR
                return {
                    restrict: 'E',
                    template: templateStr,
                    scope: {
                        /** Model (value) to select. */
                        textKey: '@',
                        /** set the Position of the Tooltip, if no Parameter is set, default behaviour like getPosition() */
                        tooltipPosition: '@?',
                    },
                    link: function ($scope, element) { // NOSONAR
                        element[0].className += ' basler-info-link';
                        $scope.helpText = undefined; //just a placeholder

                        // Get the help text from the cache or from the Magnolia CMS
                        TextRetrievalService.getInfoText($scope.textKey).then((infoText) => {
                            $scope.helpText = infoText;
                            $scope.$applyAsync(); //to fix issue "$apply already in progress" http://stackoverflow.com/questions/18626039/apply-already-in-progress-error
                        }).catch(() => {}); // prevent log an error message if an info text has not been loaded

                        // Are we running on a mobile ?
                        const isTouchDevice = 'ontouchstart' in document.documentElement;

                        // Display the info text
                        $scope.getPosition = () => {
                            if ($scope.tooltipPosition === undefined) {
                                if ($(window).width() <= 640) {
                                    return 'bottom-right';
                                }
                                return 'right';
                            }

                            return $scope.tooltipPosition;
                        };

                        // Hide the info text
                        $scope.removeInfo = function () {
                            if (!isTouchDevice) {
                                element.find('div').removeClass('hover');
                                if (!element.find('div').hasClass('on')) {
                                    element.find('div.infotext').fadeOut(200);
                                }
                            }
                        };

                        // Fix the info text
                        $scope.fixInfo = function () {
                            const link = element.find('div');
                            const infoTxtObj = element.find('div.infotext');

                            if (link.hasClass('on')) {
                                link.removeClass('on');
                                infoHide(infoTxtObj);
                            } else {
                                link.addClass('on');
                                infoShow(infoTxtObj);
                            }
                        };
                    },
                };
            }];

        // Show the info text at the right place, depending on the width of the page and the height of the info text
        function infoShow(obj) {
            const height = obj.height();

            if ($(window).width() > 640) {
                obj.css('top', `${(-height / 2) + 20}px`);
            } else {
                obj.css('top', `${40}px`);
                obj.css('width', $(window).width());
                obj.css('left', `${-$(window).width() + 35}px`);
            }
            obj.fadeIn(200);
        }

        // Hide the info text
        function infoHide(obj) {
            obj.fadeOut(200);
        }
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerInfoLink.js